var BraintreeAuth = (function (BraintreeClient, BraintreeVisaCheckout, braintree, $) {
	var Braintree = function (opts) {
		this._$setup = new $.Deferred();
		this._$setupPromise = this._$setup.promise();
		$.extend(this, opts);
     };

    $.extend(Braintree.prototype, {
    	init: function () {
            
            this.visaCheckout = new BraintreeVisaCheckout();
            
            return this._initClient()
                .then($.proxy(this._initVisaCheckout, this))
        		.then(this._$setup.resolve);
        },
    	_initClient: function () {
            return BraintreeClient.init(true);
        },
        _initVisaCheckout: function (clientInstance) {
            return this.visaCheckout.init(clientInstance);
        },
    	onSetupDone: function(callback) {
    		this._$setupPromise.done(callback);
	    }
    });
    
    return Braintree;
})(window.BraintreeClient, window.BraintreeVisaCheckout, window.braintree, jQuery);